import { render, staticRenderFns } from "./permohonan-pembicara.vue?vue&type=template&id=18be0426"
import script from "./permohonan-pembicara.vue?vue&type=script&lang=js"
export * from "./permohonan-pembicara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports